export enum ActionTypeEnum {
  PACKAGE_MODAL_ON = 'PACKAGE_MODAL_ON',
  DETAIL_MODAL_ON = 'DETAIL_MODAL_ON',
  PAYMENT_MODAL_ON = 'PAYMENT_MODAL_ON',
  ADDRESS_MODAL_ON = 'ADDRESS_MODAL_ON',
  WARNING_MODAL_ON = 'WARNING_MODAL_ON',
  MODAL_OFF = 'MODAL_OFF',
}
